import { useContext } from "react";
import { Autocomplete } from "@material-ui/lab";
import { BundleContentTypeEnum } from "../../../generated/graphql";
import { ModalInput } from "../../shared/Style/Style";
import { BundleFormModalContext } from "../modals/BundleFormModalContext";

export const experiments = [
  {
    type: BundleContentTypeEnum.ArWebgl,
    text: "AR/3D експеримент",
  },
  {
    type: BundleContentTypeEnum.ExperimentVr,
    text: "VR експеримент",
  },
  {
    type: BundleContentTypeEnum.InteractiveExercise,
    text: "Інтерактивна вправа",
  },
  // {
  //   type: BundleContentTypeEnum.Quiz,
  //   text: "Вікторина",
  // },
];

export const SelectModelType = () => {
  const { modelData, errors, updateModelData, handleError } = useContext(
    BundleFormModalContext,
  );

  return (
    <>
      <Autocomplete
        disabled={!!modelData.id}
        options={experiments.map((item) => item.type)}
        onChange={(_, value) => updateModelData("contentType", value as BundleContentTypeEnum)}
        onFocus={() => handleError("contentType", false)}
        getOptionLabel={(option) =>
          experiments.find((item) => item.type === option)?.text
        }
        value={
          experiments.find((item) => item.type === modelData.contentType)?.type
        }
        renderInput={(params) => (
          <ModalInput
            {...params}
            error={errors.contentType}
            label="Тип контента *"
          />
        )}
      />
    </>
  );
};
